<template>
    <div>
        <MercenaryHeader :title="'트레이닝 관리'" :back-title="'뒤로가기'" :close-action="() => { $GlobalStore.closeLastModal() }"></MercenaryHeader>
        <div v-if="is_loaded" style="flex:1; overflow: auto;">
            <div style="color:#210F03; font-size:20px; font-weight:bold;padding:20px 10px 0px 10px;">내 트레이닝</div>
            <div class="each_row" style="display:flex; padding:20px 0px;" v-for="each, i in join_schedules" :key="i" @click="showTeamTrainingMngDetail(each.idx)">
                <div style="width:60px; display:flex; justify-content: center;">
                    <img v-if="each.slider_images.length > 0" :src="$resourcePath + each.slider_images[0].thumb_image_path" style="width:40px; height:40px; border-radius:8px;">
                </div>
                <div style="flex:1; padding-top:3px;">
                    <div style="color:#210F03; font-weight:bold; font-size:14px;">{{each.title}}</div>
                    <div style="font-size:12px; color:#808080; font-weight:500; margin-top:3px;">
                        {{each.creator.nic_name}}
                        <img v-if="each.creator.team_type === TEAM_TYPE.CLASS_1_PRO_TEAM" :src="require('@/assets/img/blue_star.png')" style="vertical-align:bottom;width:12px; height:12px;">
                        <img v-else :src="require('@/assets/img/yellow_star.png')" style="vertical-align:bottom;width:12px; height:12px;">
                    </div>
                    <div style="font-size:12px; font-weight:500; color:#606060;margin-top:5px; display: flex; align-items: center;flex-wrap: wrap; line-height:20px;">
                        {{$Util.getMMDDDayHangulStr(each.join_date)}} {{each.begin_time}}~{{each.end_time}}
                        <div style="display: inline-block; width: 2px; height: 2px; border-radius: 50%; background: rgba(33, 15, 3, 0.698); margin:0px 5px; line-height:20px;"></div>
                        <div style="display: inline-block;  line-height:20px;">{{each.place_name}}</div>
                    </div>
                    <div @click.stop="() => {}">
                        <div style="color:var(--color-main); font-size:14px; font-weight:500;margin-top:15px; display:inline-block;" @click.stop="showTeamTrainingDetail(each.idx)">자세히 보기</div>
                    </div>

                </div>
                <div style="display:grid; place-items: center; padding:0px 10px;">
                    <img :src="require('@/assets/images/mypage/ico-move.png')" style="width:10px;">
                </div>
            </div>
            <div style="height:20px; background-color: #f5f5f5;"></div>
            <div style="padding:20px 10px; color:#4B8AFF; font-size:15px; font-weight:500;" @click="showTeamTrainingMngHistory">트레이닝 내역 보기</div>
        </div>
        <div style="position:fixed; right: 12px; bottom: 40px;" @click="showMakeClassScheduleFeed">
            <img :src="require('@/assets/img/feed_add_btn.png')" style="width:52px; height:52px;">
        </div>
    </div>
</template>

<script>
    import MercenaryHeader from "../../common/MercenaryHeader";
    import {JOIN_SCHEDULE_TYPE, JOIN_STATE, TEAM_TYPE} from "../../../Constants";
    export default {
        name: "TeamTrainingMng",
        components: {MercenaryHeader},
        data(){
            return {
                join_schedules : [],
                is_loaded : false,
                TEAM_TYPE: TEAM_TYPE
            }
        },
        methods : {
            showTeamTrainingDetail(idx){
                this.$GlobalStore.addModal('TeamTrainingDetail', { scheduleIdx: idx })
            },
            showMakeClassScheduleFeed(){
                this.$GlobalStore.addModal('MakeClassScheduleFeedPopup', {completeAction : () => {
                        this.getMyTrainings();
                    }
                })
            },
            async getMyTrainings(){
                const parameters = {};
                parameters.state = JOIN_STATE.OPEN;
                parameters.type = JOIN_SCHEDULE_TYPE.LESSON_SCHEDULE;
                parameters.is_open = '1';
                parameters.is_without_paging = true;
                parameters.sort = 'new';
                parameters.is_with_repeat_schedule = true;
                parameters.is_with_images = true;
                parameters.is_with_creator = true;
                parameters.filter = 'made_by_me';

                const res = await this.$Axios.get('/api/join/schedule/list', {params : parameters});
                this.is_loaded = true;
                this.join_schedules = res.data.join_schedules;
            },
            showTeamTrainingMngDetail(join_schedule_idx){
                this.$GlobalStore.addModal('TeamTrainingMngDetail', {join_schedule_idx : join_schedule_idx, completeAction : () => {
                        this.getMyTrainings();
                    }})
            },
            showTeamTrainingMngHistory(){
                this.$GlobalStore.addModal('TeamTrainingMngHistory')
            }
        },
        created(){
            this.getMyTrainings();
        }
    }
</script>

<style scoped>
    .each_row + .each_row{border-top:1px solid #EBEBEB;}
</style>